import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import { FC } from "react";
import { FlexFieldTabList } from "../../../components/FlexFieldTab";

export interface IFlexFieldTabListPage {}

export const FlexFieldTabListPage: FC<IFlexFieldTabListPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Flex Field Tab List"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[{text: 'Flex Field Tab', navigateTo: '/flex-field-tabs/list'}]}
      mainContents={<FlexFieldTabList />}
    />
  );
};
